/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const defaultTitle = site.siteMetadata?.title

  const [envStatus, setEnvStatus] = useState("prod")

  useEffect(() => {
    if (window.location.href.indexOf("http://localhost") > -1) {
      setEnvStatus("local")
    }

    if (
      window.location.href.indexOf(
        "https://stage-connexia-outcomes.firebaseapp.com"
      ) > -1
    ) {
      setEnvStatus("stage")
    }
  }, [])

  let envJs = "https://outcomes.connexia.com/env.js"
  let customJs = "https://outcomes.connexia.com/onboarding/custom.js"

  if (envStatus === "local") {
    envJs = "/env.js"
    customJs = "/custom.js"
  }

  if (envStatus === "stage") {
    envJs = "https://stage-connexia-outcomes.firebaseapp.com/env.js"
    customJs =
      "https://stage-connexia-outcomes.firebaseapp.com/onboarding/custom.js"
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
    >
      <meta property="og:url" content="https://outcomes.connexia.com" />
      <meta property="og:title" content="Connexia Outcomes" />
      <meta property="og:type" content="article" />
      <meta
        property="og:description"
        content="La Knowledge Platform per il marketing e la comunicazione omnicanale"
      />
      <meta
        property="og:image"
        content="https://outcomes.connexia.com/img/social.jpg"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@connexia" />
      <meta name="twitter:creator" content="@connexia" />
      <meta name="twitter:title" content="Connexia Outcomes" />
      <meta
        name="twitter:description"
        content="La Knowledge Platform per il marketing e la comunicazione omnicanale"
      />
      <meta
        name="twitter:image"
        content="https://outcomes.connexia.com/img/social.jpg"
      />
      <meta
        name="description"
        content="La Knowledge Platform per il marketing e la comunicazione omnicanale"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.1/cookieconsent.min.css"
      />
      <script
        src="https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.1/cookieconsent.min.js"
        data-cfasync="false"
      />
      <script src={envJs} />
      <script src={customJs} />
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
